<template>
  <div
    class="login"
    onselectstart="return false"
    onpaste="return false"
    oncopy="return false;"
    oncut="return false;"
  >
    <b>登录{{ $route.query.acttype == 'hc_welfare' ? '' : '/注册' }}</b>
    <p>
      {{
        $route.query.acttype == 'hc_welfare'
          ? ''
          : '为确保您的数据正常，登录前请使用app登录绑定微信'
      }}
    </p>
    <div class="tel-code-wrap">
      <div class="tel-wrap">
        <div class="country" @click="countryCodeChange">
          <span class="country-code">+{{ areaCode }}</span>
          <img src="../../assets/images/jt6.png" />
        </div>
        <input
          type="tel"
          placeholder="手机号"
          maxlength="11"
          v-model="phone"
          @keyup="phoneChange"
        />
        <img
          class="del-btn"
          src="../../assets/images/close.png"
          v-if="phoneFlag"
          @click="clearPhone"
        />
      </div>
      <div class="codeWrap">
        <div class="inputWrap">
          <input
            placeholder="图形验证码"
            maxlength="4"
            v-model="imgCodeValue"
            @keyup="imgCodeChange"
          />
          <img
            class="del-btn"
            src="../../assets/images/close.png"
            v-if="imgCodeFlag"
            @click="clearImgCode"
          />
        </div>
        <div class="codeImg" ref="codeImg" @click="getCodeImg">
          <img :src="codeImg" />
        </div>
      </div>
      <div :class="['active', 'btn-submit']" @click="getCodeMessage">获取验证码</div>
    </div>
    <div class="flex" v-if="$route.query.acttype != 'hc_welfare'">
      <van-checkbox v-model="checked" checked-color="#FC0324" icon-size="14">
        <p class="agreement">点击登录表示已阅读并同意</p>
      </van-checkbox>
      <p class="agreement" @click="agreement"><span>《用户协议》</span></p>
    </div>
  </div>
</template>

<script>
import { basepath, encryption, unencryption, random_string } from '../../assets/common/js/config'
export default {
  name: 'loginIn',
  data() {
    return {
      areaCode: '86', // 国际区号
      phone: '', // 手机号
      codeImg: null, // 图片验证码
      timeout: null, // 事件随机码
      imgCodeValue: '', // 图片验证码-值
      phoneFlag: false, // 手机号-删除按钮
      imgCodeFlag: false, // 图片验证码-删除按钮
      passFlag: false, // 初步校验
      checked: true // 默认同意用户协议
    }
  },
  mounted: function() {
    if (this.$route.query.acttype == 'hc_welfare') this.getData()
    if (this.$route.query.isagree == 2) {
      this.checked = false
    }
    if (sessionStorage.getItem('ckys_wap_tel')) {
      this.phoneFlag = true
      this.phone = unencryption(sessionStorage.getItem('ckys_wap_tel'))
    }
    if (this.$route.query.area_code) {
      this.areaCode = this.$route.query.area_code
    }

    this.getCodeImg()
  },
  destroyed: function() {},
  watch: {},
  methods: {
    getData: function() {
      var url = this.$ajax.check_URL
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          if (res.data.status != 1) {
            this.$router.replace('/')
          }
        }
      })
    },
    // 国际区号
    countryCodeChange() {
      if (this.phone) {
        sessionStorage.setItem('ckys_wap_tel', encryption(this.phone))
      } else {
        sessionStorage.setItem('ckys_wap_tel', this.phone)
      }
      this.$router.replace({
        path: '/country',
        query: {
          type: 'login',
          routeval: this.$route.query.routeval,
          acttype: this.$route.query.acttype || ''
        }
      })
    },
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg =
        basepath +
        'Msg/Captcha/getValidateCode?sessionid=' +
        this.timeout +
        '&width=' +
        width +
        '&height=' +
        height
    },
    // 检测手机号改变
    phoneChange() {
      this.phoneFlag = !!this.phone
      this.checkInfo()
    },
    // 清除手机号
    clearPhone() {
      this.phone = ''
      this.phoneFlag = !!this.phone
      this.checkInfo()
    },
    // 检测图形验证码-值改变
    imgCodeChange() {
      this.imgCodeFlag = !!this.imgCodeValue
      this.checkInfo()
    },
    // 清除图片验证码的值
    clearImgCode() {
      this.imgCodeValue = ''
      this.imgCodeFlag = false
      this.checkInfo()
    },
    // 检测手机号、图形验证码长度
    checkInfo: function() {
      this.passFlag = !!(this.phone.length == 11 && this.imgCodeValue.length == 4)
    },
    // 勾选用户协议
    agreement: function() {
      if (this.phone) {
        sessionStorage.setItem('ckys_wap_tel', encryption(this.phone))
      } else if (this.phone) {
        sessionStorage.setItem('ckys_wap_tel', this.phone)
      }
      this.$router.replace({
        path: '/agreement',
        query: {
          routeval: this.$route.query.routeval,
          type: 'login',
          acttype: this.$route.query.acttype || ''
        }
      })
    },
    checkPhone: function() {
      if (!/^1[3456789]\d{9}$/.test(this.value)) {
        return false
      } else {
        if (!this.checked) {
          return false
        } else {
          return true
        }
      }
    },
    getCodeMessage() {
      if (this.phone == '') {
        this.$toast('手机号码不能为空')
        return
      } else if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$toast('手机号码输入有误')
        return
      } else if (this.imgCodeValue == '') {
        this.$toast('验证码不能为空')
        return
      } else if (this.imgCodeValue.length < 4) {
        this.$toast('验证码输入有误')
        return
      } else if (!this.checked && this.$route.query.acttype != 'hc_welfare') {
        this.$toast('请先同意软件协议')
        return
      }

      let that, url

      that = this
      url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.phone +
        '&code=' +
        this.imgCodeValue +
        '&sessionid=' +
        this.timeout +
        '&type=3' +
        '&area_code=' +
        this.areaCode

      that.$toast.loading({
        mask: false,
        message: '加载中...',
        duration: 0,
        forbidClick: true
      })
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.$toast({
            message: '提交成功',
            icon: require('../../assets/images/succ.png')
          })
          if (that.phone) {
            sessionStorage.setItem('ckys_wap_tel', encryption(that.phone))
          } else {
            sessionStorage.setItem('ckys_wap_tel', that.phone)
          }

          sessionStorage.setItem('ckys_wap_imgCodeValue', that.imgCodeValue)
          sessionStorage.setItem('ckys_wap_area_code', that.areaCode)
          sessionStorage.setItem('ckys_wap_sessionid', that.timeout)
          console.log('timeout', that.timeout)
          var obj = that.$route.query
          that.$router.replace({
            path: '/code',
            query: obj
          })
        } else if (res.data.code == '10011') {
          that.clearImgCode()
          that.getCodeImg()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.login {
  padding: 0 0.3rem;
  background: #fff;
  b {
    margin-top: 0.62rem;
    display: block;
    font-size: 0.29rem;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 0.41rem;
  }
  p {
    margin-top: 0.03rem;
    margin-bottom: 0.53rem;
    font-size: 0.14rem;
    font-weight: 400;
    color: rgba(136, 136, 136, 1);
    line-height: 0.2rem;
  }
  .tel-code-wrap {
    font-size: 0.16rem;
    .del-btn {
      width: 0.13rem;
      height: 0.13rem;
      position: absolute;
      top: 0;
      right: 0;
      margin: 0.15rem 0.09rem;
    }
    .tel-wrap {
      position: relative;
      display: flex;
      align-items: center;
      height: 0.44rem;
      font-size: 0.16rem;
      border-radius: 0.22rem;
      background: #f7f7f7;
      .country {
        display: flex;
        align-items: center;
        padding: 0 0.1rem 0 0.15rem;
        img {
          width: 0.16rem;
          height: 0.16rem;
          padding: 0.06rem 0.05rem 0.06rem 0.03rem;
        }
      }
      input {
        background: none;
        outline: none;
        border: none;
      }
    }
    .codeWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.15rem;
      .inputWrap {
        flex: 1 1 0%;
        position: relative;
        border-radius: 0.22rem;
        padding-left: 0.15rem;
        height: 0.44rem;
        line-height: 0.44rem;
        background: #f7f7f7;
        font-size: 0.16rem;
        color: #000;
        input {
          background: none;
          outline: none;
          border: none;
        }
      }
      .codeImg {
        height: 0.36rem;
        width: 34.5%;
        background: rgb(238, 238, 238);
        margin-left: 0.1rem;
        overflow: hidden;
      }
    }
    .btn-submit {
      margin-top: 0.27rem;
      margin-bottom: 0.17rem;
      width: 100%;
      text-align: center;
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      border-radius: 0.25rem;
      opacity: 0.39;
      font-size: 0.17rem;
      font-weight: 400;
      color: #fff;
      line-height: 0.24rem;
      padding: 0.1rem 0;
      &.active {
        opacity: 1;
      }
    }
  }
  .flex {
    display: flex;
  }
  .agreement {
    margin: 0;
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(166, 166, 166, 1);
    line-height: 0.17rem;
    span {
      color: #4a90e2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/loginIn.vue